export default __webpack_public_path__ + "static/media/remmita.03ccc7a0.jpeg";